
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class PrintOrX extends Vue {
  @Prop() value!: string;
}
